import React, { useMemo } from 'react';
import { UiConfigStateContext } from './UiConfigContext';
import { useVideoConfig } from '../../config/VideoAppContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const UiConfigProvider = ({
  children,
  providerSettings
}) => {
  const {
    uiConfig
  } = useVideoConfig();
  const {
    default: defaultConfig
  } = uiConfig;
  const config = useMemo(() => {
    switch (providerSettings.type) {
      case 'PageId':
        return uiConfig[providerSettings.value] ?? defaultConfig;
      case 'CustomConfig':
        return providerSettings.value;
      default:
        return defaultConfig;
    }
  }, [defaultConfig, providerSettings.type, providerSettings.value, uiConfig]);
  return /*#__PURE__*/_jsx(UiConfigStateContext.Provider, {
    value: config,
    children: children
  });
};